/* =============================================
   YOU GLOWING INC. — Theme JavaScript
   ============================================= */
(function () {
  'use strict';

  /* ------------------------------------------
     GLITTER CANVAS ENGINE
     Call initGlitterCanvas(canvasEl) for any canvas.
     Auto-finds all #glitter-canvas elements on load.
  ------------------------------------------ */
  var COLORS = [
    'rgba(201,168,76,',
    'rgba(232,201,122,',
    'rgba(247,237,208,',
    'rgba(123,79,166,',
    'rgba(176,141,212,',
    'rgba(255,255,255,',
    'rgba(244,167,192,',
  ];

  function Particle(W, H, initial) {
    this.W = W; this.H = H;
    this.reset(initial);
  }

  Particle.prototype.reset = function (initial) {
    this.x      = Math.random() * this.W;
    this.y      = initial ? Math.random() * this.H : -8;
    this.size   = Math.random() * 2.6 + 0.5;
    this.speedY = Math.random() * 0.55 + 0.18;
    this.speedX = (Math.random() - 0.5) * 0.35;
    this.opacity    = Math.random() * 0.85 + 0.15;
    this.opacityDir = (Math.random() > 0.5 ? 1 : -1) * (Math.random() * 0.007 + 0.003);
    this.color  = COLORS[Math.floor(Math.random() * COLORS.length)];
    this.angle  = Math.random() * Math.PI * 2;
    this.spin   = (Math.random() - 0.5) * 0.055;
    this.shape  = Math.floor(Math.random() * 4);
    this.twinkle = Math.random() > 0.45;
  };

  Particle.prototype.draw = function (ctx) {
    ctx.save();
    ctx.globalAlpha = Math.max(0, Math.min(1, this.opacity));
    ctx.fillStyle   = this.color + this.opacity + ')';
    ctx.strokeStyle = this.color + this.opacity + ')';
    ctx.translate(this.x, this.y);
    ctx.rotate(this.angle);
    var s = this.size;
    ctx.beginPath();
    if (this.shape === 0) {
      ctx.moveTo(0, -s * 1.6); ctx.lineTo(s, 0);
      ctx.lineTo(0, s * 1.6);  ctx.lineTo(-s, 0);
      ctx.closePath(); ctx.fill();
    } else if (this.shape === 1) {
      var inner = s * 0.4, outer = s * 1.4;
      for (var i = 0; i < 8; i++) {
        var r = i % 2 === 0 ? outer : inner;
        var a = (i * Math.PI) / 4;
        i === 0 ? ctx.moveTo(Math.cos(a)*r, Math.sin(a)*r) : ctx.lineTo(Math.cos(a)*r, Math.sin(a)*r);
      }
      ctx.closePath(); ctx.fill();
    } else if (this.shape === 2) {
      ctx.arc(0, 0, s, 0, Math.PI * 2); ctx.fill();
    } else {
      ctx.lineWidth = Math.max(0.5, s * 0.4);
      ctx.moveTo(0, -s*1.8); ctx.lineTo(0, s*1.8);
      ctx.moveTo(-s*1.8, 0); ctx.lineTo(s*1.8, 0);
      ctx.stroke();
    }
    ctx.restore();
  };

  Particle.prototype.update = function () {
    this.y += this.speedY;
    this.x += this.speedX + Math.sin(this.y * 0.018) * 0.28;
    this.angle += this.spin;
    if (this.twinkle) {
      this.opacity += this.opacityDir;
      if (this.opacity > 1 || this.opacity < 0.08) this.opacityDir *= -1;
    }
    if (this.y > this.H + 10 || this.x < -20 || this.x > this.W + 20) {
      this.W = this.W; this.H = this.H;
      this.reset(false);
    }
  };

  function initGlitterCanvas(canvas) {
    if (!canvas) return;
    var section = canvas.closest('.products-section') || canvas.parentElement;
    var ctx = canvas.getContext('2d');
    var particles = [], W, H, rafId, resizeTimer;

    function resize() {
      W = canvas.width  = section.offsetWidth;
      H = canvas.height = section.offsetHeight;
    }

    function populate() {
      particles = [];
      for (var i = 0; i < 220; i++) particles.push(new Particle(W, H, true));
    }

    function animate() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < particles.length; i++) {
        particles[i].W = W; particles[i].H = H;
        particles[i].update();
        particles[i].draw(ctx);
      }
      rafId = requestAnimationFrame(animate);
    }

    resize(); populate(); animate();

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { resize(); populate(); }, 250);
    });
  }

  // expose so sections can call it
  window.initGlitterCanvas = initGlitterCanvas;

  /* ------------------------------------------
     MOBILE NAVIGATION
  ------------------------------------------ */
  function initMobileNav() {
    var hamburger = document.getElementById('hamburger');
    var mobileNav = document.getElementById('mobile-nav');
    var overlay   = document.getElementById('nav-overlay');
    var closeBtn  = document.querySelector('.mobile-nav-close');

    function open()  {
      mobileNav && mobileNav.classList.add('open');
      overlay   && overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      hamburger && hamburger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      mobileNav && mobileNav.classList.remove('open');
      overlay   && overlay.classList.remove('open');
      document.body.style.overflow = '';
      hamburger && hamburger.setAttribute('aria-expanded', 'false');
    }

    hamburger && hamburger.addEventListener('click', open);
    closeBtn  && closeBtn.addEventListener('click', close);
    overlay   && overlay.addEventListener('click', close);
  }

  /* ------------------------------------------
     STICKY HEADER
  ------------------------------------------ */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 20
        ? '0 4px 28px rgba(201,168,76,0.18)'
        : '0 2px 20px rgba(201,168,76,0.06)';
    }, { passive: true });
  }

  /* ------------------------------------------
     PRODUCT GALLERY THUMBNAILS
  ------------------------------------------ */
  function initGallery() {
    var thumbs  = document.querySelectorAll('.product-thumb');
    var mainImg = document.getElementById('main-product-img');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        mainImg.src = thumb.dataset.src || thumb.querySelector('img').src;
      });
    });
  }

  /* ------------------------------------------
     ADD TO CART FEEDBACK
  ------------------------------------------ */
  function initCartButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add-to-cart-btn, .product-add-btn');
      if (!btn || btn.disabled) return;
      var orig = btn.innerHTML;
      btn.innerHTML = '&#10003; Added!';
      btn.style.background = 'linear-gradient(135deg,#7B4FA6,#4a1d82)';
      setTimeout(function () {
        btn.innerHTML = orig;
        btn.style.background = '';
      }, 2000);
    });
  }

  /* ------------------------------------------
     QUANTITY BUTTONS
  ------------------------------------------ */
  function initQtyButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty-btn');
      if (!btn) return;
      var row   = btn.closest('.cart-item-qty');
      if (!row) return;
      var input = row.querySelector('input[type=number]') || row.querySelector('.cart-qty-val');
      if (!input) return;
      var val = parseInt(input.value || input.textContent, 10) || 1;
      if (btn.dataset.action === 'increase') val += 1;
      if (btn.dataset.action === 'decrease') val = Math.max(0, val - 1);
      if (input.tagName === 'INPUT') input.value = val;
      else input.textContent = val;
    });
  }

  /* ------------------------------------------
     SCROLL REVEAL
  ------------------------------------------ */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll(
      '.product-card, .testimonial-card, .collection-tile, .value-item, .about-image-stack, .about-content'
    );
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity   = '1';
          entry.target.style.transform = 'translateY(0)';
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -28px 0px' });

    els.forEach(function (el, i) {
      el.style.opacity    = '0';
      el.style.transform  = 'translateY(22px)';
      el.style.transition = 'opacity 0.6s ease ' + (i * 0.055) + 's, transform 0.6s ease ' + (i * 0.055) + 's';
      obs.observe(el);
    });
  }

  /* ------------------------------------------
     NEWSLETTER
  ------------------------------------------ */
  function initNewsletter() {
    var form = document.querySelector('.newsletter-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.btn');
      if (btn) {
        btn.textContent = "&#10003; You're in!";
        btn.style.background = 'linear-gradient(135deg,#7B4FA6,#4a1d82)';
      }
    });
  }

  /* ------------------------------------------
     WISHLIST TOGGLE
  ------------------------------------------ */
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="wishlist"]');
      if (!btn) return;
      var active = btn.dataset.active === 'true';
      btn.dataset.active = String(!active);
      btn.textContent    = active ? '♡' : '♥';
      btn.style.color    = active ? '' : '#D4678A';
    });
  }

  /* ------------------------------------------
     VARIANT RADIO HIGHLIGHT
  ------------------------------------------ */
  function initVariants() {
    document.querySelectorAll('.product-info input[type=radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        document.querySelectorAll('input[name="' + radio.name + '"]').forEach(function (r) {
          var span = r.closest('label') && r.closest('label').querySelector('span');
          if (!span) return;
          span.style.borderColor = r.checked ? 'var(--gold)'      : 'var(--border)';
          span.style.background  = r.checked ? 'var(--gold-pale)' : '';
          span.style.fontWeight  = r.checked ? '600'              : '';
        });
      });
    });
  }

  /* ------------------------------------------
     INIT ALL
  ------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function () {
    // Boot all glitter canvases on the page
    document.querySelectorAll('#glitter-canvas, #glitter-canvas-recs, [id^="glitter-canvas"]').forEach(function (canvas) {
      initGlitterCanvas(canvas);
    });

    initMobileNav();
    initStickyHeader();
    initGallery();
    initCartButtons();
    initQtyButtons();
    initScrollReveal();
    initNewsletter();
    initWishlist();
    initVariants();
  });

})();
